import React from "react";
import user from "../../Common/JsonFiles/simran.json";
import "./Footer.scss";

const Footer = () => {
  const openSocialPlatforms = (site) => {
    window.open(site);
  };
  return (
    <div className="footer-main">
      <footer class="text-center text-white footer-back">
        <div class="container p-t-2">
          <section class="mb-5">
            <div class="row d-flex justify-content-center">
              <div class="col-lg-8">
                <h3>{user?.name}</h3>
                <p>{user?.designation}</p>
              </div>
            </div>
          </section>

          <section class="text-center mb-5">
            <ul class="d-flex a-i-c footer-soc-icons">
              {user?.socialSites?.map((item,id) => (
                <li  key={id.toString()} onClick={() => openSocialPlatforms(item?.url)}>
                  <span class={`social-icon social-${item?.name}`}>
                    <i class={`fa fa-${item?.name}`}></i>
                  </span>
                </li>
              ))}
            </ul>
          </section>
        </div>

        <div
          class="text-center p-3"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
        >
          © 2020 Copyright:{" "}
          <a class="text-white copyright" href="">
            {user?.name}
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
